<template>
    <div class="content">
        <div class="content" v-if="nNumber>=4">
            <div :class="['move_list',bBackfoued?'no_active_back_item':'']" @click="last">
                <img src="~@/assets/images/pagin/last_icon.png" alt="">
            </div>
            <div :class="['move_list',page == 1&&!bBackfoued?'active_item':page == 1&&bBackfoued?'active_back_item':page!=1&&bBackfoued?'no_active_back_item':'']" @click="getActive(1)">1</div>
            <div :class="['move_list',bBackfoued?'no_active_back_item':'']" v-if="page>2&&nNumber >4">...</div>
            <div :class="['move_list',page == item&&!bBackfoued?'active_item':page == item&&bBackfoued?'active_back_item':page!=item&&bBackfoued?'no_active_back_item':'']" v-for="(item,index) in getNumber(nNumber)"
                @click="getActive(item)" :key="index">
                {{item}}
            </div>
            <div :class="['move_list',bBackfoued?'no_active_back_item':'']" v-if="page <nNumber - 2&&nNumber >4&&page != nNumber">...</div>
            <div :class="['move_list',page == nNumber&&!bBackfoued?'active_item':page == nNumber&&bBackfoued?'active_back_item':page!=nNumber&&bBackfoued?'no_active_back_item':'']" @click="getActive(nNumber)">{{nNumber}}
            </div>
            <div :class="['move_list',bBackfoued?'no_active_back_item':'']" @click="next">
                <img src="~@/assets/images/pagin/next_icon.png" alt="">
            </div>
        </div>
        <div class="content" v-if="nNumber<4">
            <div :class="['move_list',bBackfoued?'no_active_back_item':'']" @click="last">
                <img src="~@/assets/images/pagin/last_icon.png" alt="">
            </div>
            <div :class="['move_list',item == page&&!bBackfoued?'active_item':page == item&&bBackfoued?'active_back_item':page!=item&&bBackfoued?'no_active_back_item':'']" v-for="(item,index) in getNumberTwo(nNumber)"
                @click="getActive(item)" :key="index">
                {{item}}
            </div>
            <div :class="['move_list',bBackfoued?'no_active_back_item':'']" @click="next">
                <img src="~@/assets/images/pagin/next_icon.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // 是否需要背景颜色
        bBackfoued: {
            type: Boolean,
            default: () => false,
        },
        // 总页数
        nNumber: {
            type: Number,
            default: () => 1,
        },
        //当前页数
        page: {
            type: Number,
            default: () => 1,
        },
    },
    data() {
        return {
            arrPernum: [],
        };
    },
    filters: {},
    methods: {
        getActive(i) {
            let _that = this;
            //_that.page = i;
            _that.$emit("active", i);
        },
        last() {
            let _that = this;
            if (_that.page == 1) {
                return;
            }
            // _that.page -= 1;
            _that.$emit("last",_that.page-1);
        },
        next() {
            let _that = this;
            if (_that.page == _that.nNumber) {
                return;
            }
            //_that.page += 1;
            _that.$emit("next", _that.page + 1);
        },
        getNumber(num) {
            let _that = this;
            let arrPernum = [];
            for (let i = 1; i < num; i++) {
                if (_that.page == 1 && i == _that.page) {
                    arrPernum.push(i + 1);
                    arrPernum.push(i + 2);
                } else if (
                    i == _that.page &&
                    _that.page != 1 &&
                    _that.page != _that.nNumber - 1
                ) {
                    arrPernum.push(i);
                    arrPernum.push(i + 1);
                } else if (i == _that.page && _that.page == _that.nNumber - 1) {
                    arrPernum.push(i - 1);
                    arrPernum.push(i);
                } else if (i + 1 == _that.page && _that.page == _that.nNumber) {
                    arrPernum.push(i - 1);
                    arrPernum.push(i);
                }
            }
            _that.arrPernum = arrPernum;
            return arrPernum;
        },
        getNumberTwo(num) {
            let _that = this;
            let arrPernum = [];
            for (let i = 0; i < num; i++) {
                arrPernum.push(i + 1);
            }
            _that.arrPernum = arrPernum;
            return arrPernum;
        },
    },
    mounted() {
        // console.log(this.nNumber)
    },
};
</script>

<style lang="scss" scoped>
.content {
    padding: 0 10px 10px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .move_list {
        width: 64px;
        height: 64px;
        border-radius: 8px;
        border: 1px solid #e6efe8;
        font-size: 28px;
        color: #444444;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 8px;
        background: #fff;
    }
    .active_item {
        border: 1px solid $deepGreen;
        color: $deepGreen;
    }
    .active_back_item {
        color: #fff;
        background: $deepGreen;
    }
    .no_active_back_item {
        background: #e6efe8;
        color: #444444;
    }
}
</style>